import './App.css';
import React from 'react';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './components/utils/Auth';
import Header from './components/Header';
import Footer from './components/Footer';
import BodyContent from './components/BodyContent';
import { Container } from '@mui/material';

function App() {

  return (
    <div className="App">
      <AuthProvider>
        <SnackbarProvider
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}>

          <Header />
          <div className='content-wrap'>
            <Container sx={{ display: 'flex' }} maxWidth="xlg">
              <BodyContent />
            </Container>
          </div>
          <Footer />
        </SnackbarProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
